import React, { ComponentPropsWithoutRef, FC } from 'react';

import { styled } from '@mui/material/styles';

import Checkbox from '~/components/Checkbox/Checkbox';
import StarConfetti, {
  usePlayStarConfetti,
  StarConfettiWrapper,
} from '~/components/OnboardingModal/components/StarConfetti';

interface CheckboxWithStarConfettiProps extends ComponentPropsWithoutRef<typeof Checkbox> {
  withoutConfetti?: boolean;
  isExtendedConfetti?: boolean;
}

const CheckboxWithStarConfetti: FC<CheckboxWithStarConfettiProps> = ({
  withoutConfetti,
  isExtendedConfetti,
  ...rest
}) => {
  const { scope, play } = usePlayStarConfetti();

  return (
    <StarConfettiWrapper>
      <StyledStarConfetti ref={scope} />
      <Checkbox
        {...rest}
        onChange={(event) => {
          if (!rest.checked && !withoutConfetti) {
            play(isExtendedConfetti);
          }
          rest.onChange?.(event);
        }}
      />
    </StarConfettiWrapper>
  );
};

export default CheckboxWithStarConfetti;

const StyledStarConfetti = styled(StarConfetti)`
  left: -9px;
  top: -7px;
`;
